import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
var INITIAL_STATE = {
  businessName: "",
  contactEmail: "",
  details: "",
  emailErrorMessage: undefined,
  descriptionErrorMessage: undefined,
  businessNameErrorMessage: undefined,
  formErrorMessage: ""
};
var _createContextStore = createContextStore(INITIAL_STATE),
  useLoggedOutEmailContextStore = _createContextStore.useStore,
  LoggedOutEmailContextProvider = _createContextStore.Provider;
export { LoggedOutEmailContextProvider, useLoggedOutEmailContextStore };